import styles from './NoAccess.module.css';

const NoAccess = () => {
    return (
        <div className={styles.container}>
            <div>
                <h1 className={styles.title}>Creatorbase access required</h1>
                <p className={styles.copy}>
                    This app is for creatorbase accounts, and your account doesn't have creatorbase access.
                </p>
            </div>
        </div>
    );
};

export default NoAccess;
